"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.efacturaMarkSentSchema = exports.efacturaSettingsSchema = exports.EfacturaEnvironment = void 0;
const zod_1 = require("zod");
/**
 * Mediul ANAF pe care se face upload-ul. OAuth-ul (logincert.anaf.ro) e comun
 * ambelor medii; doar baza API FCTEL diferă (`/test` vs `/prod`). Se pornește
 * pe `test` și se comută pe `prod` per firmă, după validare.
 */
exports.EfacturaEnvironment = {
    test: 'test',
    prod: 'prod',
};
/**
 * Setările e-Factura editabile per firmă (tab-ul „e-Factura" din drawer-ul
 * firmei). Toate opționale — un PATCH atinge doar ce s-a schimbat. Token-urile
 * NU se setează de aici; ele vin exclusiv din fluxul OAuth.
 */
exports.efacturaSettingsSchema = zod_1.z
    .object({
    environment: zod_1.z.enum([exports.EfacturaEnvironment.test, exports.EfacturaEnvironment.prod]),
    autoSend: zod_1.z.boolean(),
    autoRefresh: zod_1.z.boolean(),
})
    .partial();
/** Payload pentru marcarea manuală a unei facturi ca „deja în SPV". */
exports.efacturaMarkSentSchema = zod_1.z
    .object({
    /** Indexul de încărcare ANAF, dacă îl cunoști (opțional). */
    uploadIndex: zod_1.z.string().trim().min(1),
})
    .partial();
